var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.477,
    height: 32,
    viewBox: "0 0 28.477 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.047,32a9.047,9.047,0,0,1-6.4-15.445L17.288,1.917a6.556,6.556,0,0,1,9.271,9.272L13.63,24.119A4.065,4.065,0,0,1,7.882,18.37l9.442-9.443A1.187,1.187,0,0,1,19,10.606L9.56,20.048a1.691,1.691,0,1,0,2.392,2.392l12.93-12.93A4.183,4.183,0,0,0,18.966,3.6L4.328,18.233a6.674,6.674,0,1,0,9.439,9.439L24.917,16.521A1.187,1.187,0,1,1,26.6,18.2L15.445,29.35A8.989,8.989,0,0,1,9.047,32",
    transform: "translate(0 0)",
    fill: "#724bd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachicon);
export default __webpack_public_path__ + "static/media/Attachicon.03b16fd0b797bcf1e85f608f25d7cd8e.svg";
export { ForwardRef as ReactComponent };